import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisation OrganisationModel
 * @param blockUI boolean
 *
 * @return {Promise<any>|Promise}
 */
export default (function (organisation, blockUI) {
    var url = applyPathVariables(EndPoints.ORGANISATION_FEEDS, { organisationId: organisation.id });
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true, blockUI: blockUI });
    return request.execute();
});
